import styled from 'styled-components'

export const StTitle = styled.h1`
  font-size: 3.25rem;
  margin-bottom: 3rem;
  text-align: center;
`
